import React from "react";

function TextNormal(props) {
  return (
    <p className="mb-4">{props.text}</p>
  );
}

export default TextNormal;